import script from "./MajorSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MajorSituation.vue?vue&type=script&lang=ts&setup=true"

import "./MajorSituation.vue?vue&type=style&index=0&id=06496062&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06496062"]])

export default __exports__